import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

export const useSourceSelectOptions = () => {
    const { t } = usePaldockTranslation("general.conversion_source");

    // Static options: iframe, api, link with translations
    const options = [
        { label: t("iframe"), value: "iframe" },
        { label: t("api"), value: "api" },
        { label: t("link"), value: "link" },
    ];

    return { options, loading: false, error: null };
};
